export const FLAG_GETTING_HOLIDAYS = 'FLAG_GETTING_HOLIDAYS';
export const GET_HOLIDAYS = 'GET_HOLIDAYS';
export const CLEAR_HOLIDAYS = 'CLEAR_HOLIDAYS';
export const FLAG_HOLIDAY_ACTIVITY = 'FLAG_HOLIDAY_ACTIVITY';
export const GET_HOLIDAY = 'GET_HOLIDAY';
export const CLEAR_HOLIDAY = 'CLEAR_HOLIDAY';
export const GET_HOLIDAY_DATES = 'GET_HOLIDAY_DATES';
export const FLAG_GETTING_HOLIDAY_DATES = 'FLAG_GETTING_HOLIDAY_DATES';
export const CLEAR_HOLIDAY_DATES = 'CLEAR_HOLIDAY_DATES';